import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Icon } from 'gu-ui-kit'
import styles from 'components/Footer/footer.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import LanguageSelector from 'components/Footer/subcomponents/LanguageSelector'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { APP_PRODUCT } from 'constants/app-config'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import { PANEL_NAVIGATE } from 'modules/Tickets/types'

const Footer = () => {
  const pathGen = useGeneratePathI18n()
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['common'])
  const { i18n } = useSelector(({ app }) => app)
  const dispatch = useDispatch()

  return (
    <Grid
      alignItems={'center'}
      justifyContent={'between'}
      className={styles['footer']}
      fluid={false}
      wrap={'nowrap'}
      direction={'column'}
      md={{
        direction: 'row',
      }}
    >
      <Grid
        alignItems={'center'}
        justifyContent={'space-between'}
        fluid={false}
        className={styles['footer__side']}
      >
        <div className={styles['footer__copyrights']}>
          2018 – {new Date().getFullYear()} ©{' '}
          <a href={pathGen(ROUTES.MAIN)}>{APP_PRODUCT}</a>
        </div>

        <Grid
          fluid={false}
          wrap={'nowrap'}
          className={styles['footer__ps-icons']}
        >
          <Icon name={'ps-visa'} width={55} height={32} />
          <Icon name={'ps-mc'} width={39} height={32} />

          {IS_APP_PRODUCT_GETUNIQ && (
            <Icon name={'ps-mir'} width={63} height={32} />
          )}
        </Grid>
      </Grid>

      <Grid
        as={'nav'}
        className={styles['footer__links']}
        fluid={false}
        justifyContent={'center'}
      >
        <a href={pathGen(ROUTES.OFERTA)}>{t('footer.user_agreement')}</a>
        <a href={pathGen(ROUTES.PRIVACY_POLICY)}>
          {t('footer.privacy_policy')}
        </a>
        <a href={pathGen(ROUTES.CONTACTS)}>{t('footer.contacts')}</a>
        <a href={pathGen(ROUTES.FAQ)}>{t('footer.help')}</a>

        {i18n !== 'cn' && IS_APP_PRODUCT_GETUNIQ && (
          <a
            href={`${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_DOMAIN}${ROUTES.BLOG_URL}`}
            rel="noreferrer"
            target="_blank"
          >
            {t('footer.blog')}
          </a>
        )}
      </Grid>

      <Grid
        wrap={'nowrap'}
        fluid={false}
        justifyContent={'between'}
        gap={breakpoints.sm ? 24 : 8}
        direction={breakpoints.fb && !breakpoints.sm ? 'column' : 'row'}
      >
        <LanguageSelector />
        <Button
          variant={'primary'}
          component={'a'}
          className={styles['footer__support-button']}
          onClick={() =>
            dispatch({
              type: PANEL_NAVIGATE,
              payload: {
                route: 'new_ticket',
                params: { id: undefined, title: '' },
              },
            })
          }
          size={'s'}
        >
          {t('footer.support')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default Footer
